import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { CHROME_GAP } from 'core/theme.tokens'

interface MobileRecordListProps {
  children: React.ReactNode
  empty?: React.ReactNode
  isEmpty?: boolean
}

export const MobileRecordList: React.FC<MobileRecordListProps> = ({
  children,
  empty = 'Nothing to show.',
  isEmpty = false,
}) => {
  if (isEmpty) {
    return (
      <Typography variant='body2' color='text.secondary' sx={{ px: 1, py: 3, textAlign: 'center' }}>
        {empty}
      </Typography>
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5, // 12px — 8px+ between 44px targets
        px: 0,
        pb: `${CHROME_GAP}px`,
      }}
    >
      {children}
    </Box>
  )
}
